export default defineNuxtPlugin(() => {
  // Minimal Nuxt Scripts example: lazy-load a small third-party library (js-confetti)
  // This plugin exposes a `jsConfetti` helper via `$jsConfetti` for pages/components
  if (!process.client) return

  const script = useScript('https://cdn.jsdelivr.net/npm/js-confetti@0.10.0/dist/js-confetti.browser.js', {
    trigger: 'manual',
  })

  return {
    provide: {
      jsConfetti: {
        load: async () => {
          if (script.load) await script.load()
          return (window as any).JSConfetti || null
        }
      }
    }
  }
})
